import { render } from "./field-list.vue?vue&type=template&id=146d7fdc&scoped=true&ts=true"
import script from "./field-list.vue?vue&type=script&lang=tsx"
export * from "./field-list.vue?vue&type=script&lang=tsx"

import "./field-list.vue?vue&type=style&index=0&id=146d7fdc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-146d7fdc"]])

export default __exports__